module.exports = __webpack_public_path__ + "img/first-section-1.0b194877.jpg";